<template>
    <div>
       <!-- 农贸 -->
    </div>
</template>

<script>
export default {
    data(){
        return{}
    },
    created(){
         this.$store.commit("solutions", -1);
        this.$store.commit("solutions", 1);
    }
}
</script>